import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import {
  DrawerType,
  IEditFormDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { DrawerEditFormInner } from "./drawer-edit-form-inner";
import { DrawerFormProviderWrapper } from "./drawer-form-provider-wrapper";

export const DrawerEditForm: FC<
  IEditFormDrawerProps & IInjectedDrawerProps
> = ({
  onCloseDrawer,
  id,
  idCopyFrom,
  entity,
  mode,
  resolveFn,
  drawerNumber,
  canResolve,
}) => {
  return (
    <CrudEditContextWrapper
      entity={entity}
      id={id}
      idCopyFrom={idCopyFrom}
      mode={mode}
    >
      <DrawerFormProviderWrapper>
        <DrawerEditFormInner
          type={DrawerType.EditForm}
          entity={entity}
          onCloseDrawer={onCloseDrawer}
          mode={mode}
          resolveFn={resolveFn}
          drawerNumber={drawerNumber}
          canResolve={canResolve}
        />
      </DrawerFormProviderWrapper>
    </CrudEditContextWrapper>
  );
};
